import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(
    private session: AuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.session.isAuthenticated()) {
      localStorage.setItem('redirect_url', state.url);
      this.router.navigate(["/login"]);
      return false;
    }

    return true;
  }

  canLoad(
    route: Route,
    segments: UrlSegment[],
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.session.isAuthenticated()) {
      const reg = /[,]/g;
      if (segments.length == 0) {
        this.router.navigate(["/login", segments.toString().replace(reg, "/")]);
      }
      if (segments[0].path == "login_interno") {
        this.router.navigate(["/login_interno"]);
      } else {
        const path = "/" + segments.toString().replace(reg, "/");
        localStorage.setItem("redirect_url", path); 
        this.router.navigate(["/login", segments.toString().replace(reg, "/")]);
      }
    }

    return true;
  }
}

// import { Injectable } from '@angular/core';
// import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
// import { Observable } from 'rxjs';
// import { AuthService } from '../auth.service';
// import { environment } from 'src/environments/environment';

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthGuard implements CanActivate, CanLoad {

//   constructor(
//               private session:AuthService,
//               private router:Router,
//             ){

//   }

//   getRedirectObj(){
//     const obj = {
//         redirect: window.location.origin
//       };
//     return btoa(JSON.stringify(obj));
//   }

//   canActivate(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
//     if (!this.session.isAuthenticated()) {
//       // guarda la URL actual antes de redirigir

//       localStorage.setItem('redirect_url', state.url);
//       window.location.href = `${environment.apiBase}/accounts/microsoft/login/?token=${this.getRedirectObj()}`;
//       return false;
//     }
//     return true;
//   }

//   canLoad(
//     route: Route,
//     segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
//     if (!this.session.isAuthenticated()) {
//       // construye la URL destino desde los segments
//       const url = '/' + segments.map(s => s.path).join('/');
//       localStorage.setItem('redirect_url', url);
//       window.location.href = `${environment.apiBase}/accounts/microsoft/login/?token=${this.getRedirectObj()}`;
//       return false;
//     }
//     return true;
//   }
// }
